/* eslint-disable max-len */
import angular from 'angular';

export default function EditRiskDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  assignControlsToRiskTypeDialog,
  controlDataService,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditRiskTypeSubmit = _handleEditRiskTypeSubmit;
  vm.handleAssignControlTypeDialog = _handleAssignControlTypeDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.newRisk = angular.copy(vm.risk);

    $scope.$on('refreshControlTypesOfRiskType', (event, opt) => {
      if (opt.riskType.customerRiskTypeId === vm.newRisk.customerRiskTypeId) {
        refreshControlTypes(opt.riskType);
      }
    });
    $scope.$on('refreshControlTypes', (event, opt) => {
      if (opt.controlType) {
        _updateControlTypes(opt.controlType);
      }
    });

    $scope.$on('pra_control-type-deleted', (event, payload) => {
      if (payload.riskType && payload.riskType.customerRiskTypeId === vm.newRisk.customerRiskTypeId) {
        if (vm.newRisk.customerControlTypes && vm.newRisk.customerControlTypes.length > 0) {
          vm.newRisk.customerControlTypes = vm.newRisk.customerControlTypes.filter(
            riskTypeControlType => riskTypeControlType.customerControlTypeId !== payload.controlType.customerControlTypeId
          );
        }
      }
    });

    loaderService.showViewLoader = false;
  }

  function _handleCloseDialogClick() {
    $rootScope.$broadcast('refreshRiskTypes');
    ssDialogService.hide(ssDialogService.dialogs.riskAdmin.editRiskTypeDialog);
  }

  function _handleEditRiskTypeSubmit() {
    if ($scope.editRiskTypeForm.$valid) {
      _saveRisk()
        .then(() => {
          $rootScope.$broadcast('refreshRiskTypes');
          $rootScope.$broadcast('refreshAssetTypes');
          if (vm.saveType === 'saveAndAddAnother') {
            _resetViewModel();
          } else {
            _closeDialog();
            loaderService.showViewLoader = false;
          }
        });
    }
  }

  function _handleAssignControlTypeDialog($event) {
    if ($scope.editRiskTypeForm.$valid) {
      const promises = [
        controlDataService.getControlTypes(),
        _saveRisk(),
      ];
      return $q.all(promises).then((results) => {
        let controlTypes = results[0].data.result;
        const assignedControlTypeIds = vm.newRisk.customerControlTypes.map(
          customerAssetControlType => customerAssetControlType.customerControlTypeId
        );
        if (assignedControlTypeIds && assignedControlTypeIds.length > 0) {
          controlTypes = controlTypes.map((controlType) => {
            if (assignedControlTypeIds.includes(controlType.customerControlTypeId)) {
              controlType.isAssigned = true;
            } else {
              controlType.isAssigned = false;
            }
            return controlType;
          });
        }

        ssDialogService.dialogs.riskAdmin.assignControlsToRiskTypeDialog = ssDialogService.alert(
          assignControlsToRiskTypeDialog.getOptions($event, {
            riskType: vm.risk,
            controlTypes,
            assetType: vm.assetType,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.riskAdmin.assignControlsToRiskTypeDialog);
      });
    }
    return false;
  }

  function _saveRisk() {
    const isNew = vm.newRisk.customerRiskTypeId <= 0;
    if (!isNew && angular.equals(vm.risk, vm.newRisk)) {
      return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    vm.newRisk.riskOnsetId = vm.newRisk.riskOnset.riskOnsetId;
    vm.newRisk.riskForewarningId = vm.newRisk.riskForewarning.riskForewarningId;
    vm.newRisk.riskDurationId = vm.newRisk.riskDuration.riskDurationId;
    vm.newRisk.riskDataConfidentialityId = vm.newRisk.riskDataConfidentiality.riskDataConfidentialityId;
    vm.newRisk.riskDataIntegrityId = vm.newRisk.riskDataIntegrity.riskDataIntegrityId;
    vm.newRisk.riskDataAvailabilityId = vm.newRisk.riskDataAvailability.riskDataAvailabilityId;
    vm.newRisk.riskDirectionId = vm.newRisk.riskDirection.riskDirectionId;
    vm.newRisk.riskTrendingId = vm.newRisk.riskTrending.riskTrendingId;
    vm.newRisk.riskAssessmentFrequencyId = vm.newRisk.riskAssessmentFrequency.riskAssessmentFrequencyId;
    vm.newRisk.riskProbabilityId = vm.newRisk.riskProbability.riskProbabilityId;
    vm.newRisk.riskClassificationId = vm.newRisk.riskClassification.riskClassificationId;
    return riskDataService.saveRiskType(vm.newRisk).then((response) => {
      if (!response.data) {
        alerts.error('Error occurred while saving the risk type.');
      } else {
        alerts.success('The risk type has been saved successfully.');
        if (isNew === true) {
          vm.newRisk.customerRiskTypeId = response.data.customerRiskTypeId;
          $rootScope.$broadcast('pra_risk-type-created', {
            riskType: vm.newRisk,
          });
        } else {
          $rootScope.$broadcast('pra_risk-type-updated', {
            riskType: response.data,
          });
        }
        vm.risk = angular.copy(vm.newRisk);
      }
      loaderService.showViewLoader = false;
    });
  }

  function refreshControlTypes(riskType) {
    vm.newRisk.customerControlTypes = vm.newRisk.customerControlTypes || [];
    vm.newRisk.customerControlTypes = riskType.customerControlTypes;
  }

  function _updateControlTypes(controlType) {
    if (vm.newRisk.customerControlTypes && vm.newRisk.customerControlTypes.length > 0) {
      const pos = vm.newRisk.customerControlTypes.findIndex(item => item.customerControlTypeId === controlType.customerControlTypeId);
      if (pos === -1) return; // Can't find the item
      vm.newRisk.customerControlTypes[pos] = controlType;
    }
  }

  // function _getAssignedControlTypes() {
  //   let getRiskType = null;
  //   if (vm.assetType) {
  //     // eslint-disable-next-line max-len
  //     getRiskType = riskDataService.getRiskTypeByAssetType(vm.newRisk.customerRiskTypeId, vm.assetType.customerAssetTypeId);
  //   } else {
  //     getRiskType = riskDataService.getRiskType(vm.riskType.customerRiskTypeId);
  //   }
  //   getRiskType.then((response) => {
  //     if (!response.data) {
  //       alerts.error('Error occurred while get the risk type.');
  //     } else {
  //       alerts.success('The risk type has been retrieved successfully.');
  //       vm.newRisk = response.data;
  //       vm.risk = angular.copy(vm.newRisk);
  //     }
  //     loaderService.showViewLoader = false;
  //   });
  // }

  function _resetViewModel() {
    const _risk = { customerRiskTypeId: 0 };
    loaderService.showViewLoader = true;
    riskDataService.getRiskTypeDefaults().then((response) => {
      _risk.riskOnset = response.data.riskOnset;
      _risk.riskForewarning = response.data.riskForewarning;
      _risk.riskDuration = response.data.riskDuration;
      _risk.riskDataConfidentiality = response.data.riskDataConfidentiality;
      _risk.riskDataIntegrity = response.data.riskDataIntegrity;
      _risk.riskDataAvailability = response.data.riskDataAvailability;
      _risk.riskDirection = response.data.riskDirection;
      _risk.riskTrending = response.data.riskTrending;
      _risk.riskAssessmentFrequency = response.data.riskAssessmentFrequency;
      _risk.riskProbability = response.data.riskProbability;
      _risk.riskClassification = response.data.riskClassification;
      $timeout(
        () => {
          vm.risk = angular.copy(_risk);
          vm.newRisk = angular.copy(_risk);
          loaderService.showViewLoader = false;
          $scope.editRiskTypeForm.$setPristine();
          $scope.editRiskTypeForm.$setUntouched();
          $timeout(
            () => {
              angular.element('#dialogContent_editRiskTypeDialog')[0].scrollTop = 0;
            }, 0
          );
        },
        100
      );
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.riskAdmin.editRiskTypeDialog);
  }
}

EditRiskDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'assignControlsToRiskTypeDialog',
  'controlDataService',
];
